import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const audiences = [{
  emoji: '🙏',
  title: 'Catequistas de parroquia',
  desc: 'Querés llegar preparado cada domingo sin pasar el sábado entero buscando materiales.'
}, {
  emoji: '📚',
  title: 'Maestros de escuela católica',
  desc: 'Necesitás recursos para integrar valores cristianos en tus clases de forma dinámica.'
}, {
  emoji: '✝️',
  title: 'Líderes de grupos juveniles o misionales',
  desc: 'Organizás encuentros con niños y querés actividades variadas con base espiritual.'
}, {
  emoji: '👨‍👩‍👧',
  title: 'Papás y mamás',
  desc: 'Querés transmitir la fe en casa de forma entretenida y significativa para tus hijos.',
  isNew: true
}];
interface AudienceProps {
  onScrollToPricing: () => void;
}
export function Audience({
  onScrollToPricing
}: AudienceProps) {
  return <section className="py-10 md:py-20 px-4 md:px-6 bg-navy-950 text-cream-50 relative overflow-hidden" data-id="element-1">
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold-500 to-transparent opacity-50" data-id="element-2"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-3">
        <div className="text-center mb-10 md:mb-16" data-id="element-4">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold mb-2 md:mb-4" data-id="element-5">
            ¿Para quién es?
          </h2>
          <p className="text-base md:text-xl text-cream-50/80" data-id="element-6">
            Diseñado para vos si trabajás con niños y la fe
          </p>
          <div className="w-16 md:w-24 h-1 bg-gold-500 mx-auto mt-4 md:mt-6 rounded-full" data-id="element-7"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-8 md:mb-12" data-id="element-8">
          {audiences.map((aud, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} whileHover={{
          y: -5,
          borderColor: '#c8a24a',
          backgroundColor: '#1e3a5f'
        }} transition={{
          duration: 0.3,
          delay: i * 0.1
        }} className="bg-navy-900 p-5 md:p-8 rounded-2xl border border-navy-800 relative cursor-default" data-id="element-9">
              {aud.isNew && <span className="absolute top-3 right-3 md:top-4 md:right-4 bg-gold-500 text-navy-950 text-[10px] md:text-xs font-bold px-2 py-1 rounded-full uppercase tracking-wider" data-id="element-10">
                  NUEVO
                </span>}
              <div className="text-3xl md:text-4xl mb-3 md:mb-4" data-id="element-11">
                {aud.emoji}
              </div>
              <h3 className="text-lg md:text-xl font-bold mb-2 font-serif" data-id="element-12">
                {aud.title}
              </h3>
              <p className="text-sm md:text-base text-cream-50/70 leading-relaxed" data-id="element-13">
                {aud.desc}
              </p>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-14">
          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} onClick={onScrollToPricing} className="inline-flex items-center gap-2 text-gold-500 hover:text-gold-400 font-medium text-sm md:text-lg transition-colors group" data-id="element-15">
            ¿No estás seguro si es para vos? Tenés 7 días de garantía
            <ArrowRight className="w-4 h-4 md:w-5 md:h-5 group-hover:translate-x-1 transition-transform" data-id="element-16" />
          </motion.button>
        </div>
      </div>
    </section>;
}